import { createFeatureSelector } from '@ngrx/store';
import { State } from '@tenants/reducers/tenant-details.reducers';

export const selectTenantDetailsState = createFeatureSelector<State>('tenantDetails');
